const relatorio_de_entrega_de_material_escolar = [
  {
    path: "/relatorio-de-entrega-de-material-escolar",
    redirect: "/relatorio_de_entrega_de_material_escolar",
    meta: {
      breadCrumb: "Gestão - Material Escolar",
    },
    children: [
      {
        path: "/relatorio-de-entrega-de-material-escolar",
        name: "relatorio_de_entrega_de_material_escolar",
        component: () =>
          import(
            "@/views/RelatorioDeEntregaMaterialEscolar/RelatorioDeEntregaMaterialEscolar.vue"
          ),
      },
    ],
  },
];

export { relatorio_de_entrega_de_material_escolar };
